import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Mobile "download the app" wall (Phelipe 2026-08-05): no longer a hard
// block — "Continue in browser anyway" dismisses it and is remembered for
// 30 days so every page load doesn't re-nag.
const KEY = "conslog-mobile-gate-dismissed-at"
const REMEMBER_MS = 30 * 24 * 60 * 60 * 1000

export default class extends Controller {
  connect() {
    let at = 0
    try { at = Number(localStorage.getItem(KEY) || 0) } catch (e) { /* private mode */ }
    if (at && Date.now() - at < REMEMBER_MS) this.element.remove()
  }

  continueInBrowser() {
    try { localStorage.setItem(KEY, String(Date.now())) } catch (e) { /* private mode */ }
    this.element.remove()
    track("Mobile App Gate Dismissed", {})
  }
}
